import script from "./RecommendVideo.vue?vue&type=script&setup=true&lang=js"
export * from "./RecommendVideo.vue?vue&type=script&setup=true&lang=js"

import "./RecommendVideo.vue?vue&type=style&index=0&id=f45650d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f45650d6"]])

export default __exports__